import { EntityAuthField, EntityAuthOption } from "src/services/link/queries/NetTypes";

export const useRenderFields = (
	fields: EntityAuthField[],
	fieldSelected: string
): EntityAuthOption[] => {
	return fields
		.filter(
			(field) =>
				field.type !== "select" &&
				field.type !== "radio" &&
				(field.visibility === null ||
					(field.visibility !== null &&
						(!field.options || field.options.length === 0) &&
						field.visibility.values?.includes(fieldSelected)))
		)
		.map((field) => ({ value: field.name, label: field.label }));
};
